var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.messages),function(msg,index){return (_vm.messages.length > 0)?_c('el-alert',{key:index,class:{'mb-2': _vm.lastIndex > index, 'mb-5': _vm.lastIndex == index},attrs:{"title":msg,"type":"error","show-icon":""}}):_vm._e()}),1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06d0a39b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/shared/components/FormAlerts.vue
// module id = 471
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 14